import React from "react";
import styled from "styled-components";

export default function Header() {
  return (
    <HeaderContainer>
      <p>"EggCoin Hacking"</p>
    </HeaderContainer>
  );
}
const HeaderContainer = styled.header`
  width: 100vw;
  height: 10vw;
  background-color: #222;
  display: flex;
  justify-content: flex-start;
  p {
    font-size: 1.3rem;
    margin: auto 0;
    padding: 0 5px;
    color: #efefef;
  }
`;
